import type { ComponentProps, HTMLAttributes } from 'react';

import { IconTraffic } from '#icons/IconTraffic';
import { type TrafficIcon } from '#types/enums';
import { logger } from '#utils/logging/logger';

type Props = {
	name?: TrafficIcon | null;
} & HTMLAttributes<SVGElement>;

export function TrafficIconComponent({ name, ...rest }: Props) {
	let iconName: ComponentProps<typeof IconTraffic>['icon'];
	let title: string;

	switch (name) {
		case 'unfall':
			iconName = 'danger';
			title = 'Unfall';
			break;

		case 'stau':
			iconName = 'trafficjam-ahead';
			title = 'Stau';
			break;

		case 'sicht':
			iconName = 'danger';
			title = 'Eingeschränkte Sicht';
			break;

		case 'engstelle':
			iconName = 'road-narrows';
			title = 'Engstelle';
			break;

		case 'baustelle':
			iconName = 'construction';
			title = 'Baustelle';
			break;

		case 'wartezeit':
			iconName = 'waitingtime';
			title = 'Wartezeit';
			break;

		case 'schnee_eisglaette':
			iconName = 'snow';
			title = 'Schnee- oder Eisglätte';
			break;

		case 'info':
			iconName = 'information';
			title = 'Information';
			break;

		case 'keins':
		case 'vorsicht':
			iconName = 'danger';
			title = 'Vorsicht';
			break;

		case 'verbot_fahrzeuge':
			iconName = 'prohibited-for-all-vehicles';
			title = 'Durchfahrverbot';
			break;

		case 'schleuder_rutschgefahr':
		case 'schleudergefahr':
			iconName = 'risk-of-skidding';
			title = 'Schleuder- oder Rutschgefahr';
			break;

		default:
			logger.error(`Missing Traffic Icon: %s.`, name);

			iconName = 'danger';
			title = 'Vorsicht';
			break;
	}

	return <IconTraffic icon={iconName} title={title} size="l" {...rest} />;
}
